export class responseParam {
    cardNumber: string;
    errorCode: string;
    errorDescription: string;
    merchantId: string;
    referenceNumber: string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/responseParam.ts